import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
import { css } from 'styled-components';
import { isDefined } from '../helpers/defined';
import { styleArrayForBreakpoints } from '../helpers/media-style';

/*
 * Wrapper that adds support to the following props
 * - 'withSpacing'
 * - 'withTopMargin'
 * - 'withBottomMargin'
 * - 'withTopPadding'
 * - 'withBottomPadding'
 */
export const fontSpacingMixin = byMedia(value => css`
    ${({
  withSpacing,
  withTopPadding
}) => (withSpacing || withTopPadding) && `padding-top: ${getPx(value)};`}
    ${({
  withTopMargin
}) => withTopMargin && `margin-top: ${getPx(value)};`}
    ${({
  withSpacing,
  withBottomMargin
}) => (withSpacing || withBottomMargin) && `margin-bottom: ${getPx(value)};`}
    ${({
  withBottomPadding
}) => withBottomPadding && `padding-bottom: ${getPx(value)};`}
  `);
export const fontSpacingKeys = ['withSpacing', 'withTopPadding', 'withTopMargin', 'withBottomMargin', 'withBottomPadding'];
/*
 * Wrapper that adds support for fixed height of typography elements
 */
export const fixedHeightMixin = lineHeight => css`
  ${({
  fixedHeight,
  lines
}) => isDefined(lines) ? styleArrayForBreakpoints([lineHeight, lines, fixedHeight], ([lineHeight, lines, fixedHeight]) => fixedHeight && lines > 0 ? `
                display: -webkit-box;
                position: relative;
                overflow: hidden;
                height: calc(${getPx(lineHeight)} * ${lines});
                -webkit-line-clamp: ${lines};
                -webkit-box-orient: vertical; 
              ` : !fixedHeight && lines > 0 ? `
                display: -webkit-box;
                position: relative;
                overflow: hidden;
                max-height: calc(${getPx(lineHeight)} * ${lines});
                -webkit-line-clamp: ${lines};
                -webkit-box-orient: vertical;
              ` : ``) : ''}
`;
export const fixedHeightKeys = ['fixedHeight', 'lines'];